import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    List,
    ListItem,
    ListItemText,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CopyrightDialog = ({ open, handleClose }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                style: { padding: "24px", borderRadius: "12px" },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontFamily: "Inter",
                    color: "#0A5B42",
                }}
            >
                Copyright and Permissions
                <IconButton onClick={handleClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Typography sx={{ mb: 2, fontFamily: "Inter" }}>
                    The material on this site is covered by the provisions of the
                    Copyright Act, and relevant Canadian laws, policies, regulations, and
                    international agreements.
                </Typography>

                <Typography
                    variant="h6"
                    sx={{ mt: 2, mb: 1, color: "#0C8F63", fontWeight: 600 }}
                >
                    Non-commercial reproduction
                </Typography>
                <Typography sx={{ mb: 1 }}>
                    Unless otherwise indicated, information on this site has been posted
                    for the purpose of making it readily available for personal and public
                    non-commercial use. The material may be reproduced, in whole or in
                    part, without charge or further permission from FYMAB Inc. and/or
                    Mindsherpa, provided that:
                </Typography>

                <List sx={{ listStyleType: "disc", pl: 4 }}>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                        <ListItemText primary="FYMAB Inc. and/or Mindsherpa is identified as the source of the material." />
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                        <ListItemText primary="The material is reproduced in full without any changes." />
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                        <ListItemText primary="No charges are made for the use of the material." />
                    </ListItem>
                </List>

                <Typography
                    variant="h6"
                    sx={{ mt: 2, mb: 1, color: "#0C8F63", fontWeight: 600 }}
                >
                    Commercial reproduction
                </Typography>
                <Typography>
                    Permission must be obtained from FYMAB Inc. and/or Mindsherpa if the
                    material is to be reproduced in whole or in part. You can contact us
                    at{" "}
                    <a
                        href="mailto:info@mindsherpa.health"
                        style={{ color: "#0A7253", textDecoration: "underline" }}
                    >
                        info@mindsherpa.health
                    </a>
                    .
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

export default CopyrightDialog;
